export const keyMenu = {
  search: 1,
  employee: 2,
}
